import { Close } from '@mui/icons-material';
import {
  Button, Dialog, IconButton, useMediaQuery, useTheme,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { useState } from 'react';
import { BUTTON_COLORS, VARIANTS } from 'shared/constants';
import NasDataGrid from 'features/networking/complex/NasDataGrid';

/**
 * @param {Object} [nasProfile=undefined] - Current NAS profile configuration
 * @param {Object} complex - Complex object containing name and buildings
 * @param {Function} setDefault - Callback function to set default NAS for buildings
 */
export default function NasEditDialog({
  nasProfile = undefined, complex, setDefault,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { name, buildings } = complex;

  const handleSave = async (rows) => {
    await setDefault(rows).then(() => {
      setIsOpen(false);
    });
  };

  return (
    <>
      <Button
        variant={VARIANTS.outlined}
        color={BUTTON_COLORS.primary}
        onClick={() => setIsOpen(true)}
        disabled={!buildings}
      >
        Buildings
      </Button>
      {buildings && (
        <Dialog
          open={isOpen}
          keepMounted
          fullWidth
          maxWidth="lg"
          fullScreen={fullScreen}
        >
          <DialogTitle>
            {`${name} Complex Configuration`}
            <IconButton
              onClick={() => setIsOpen(false)}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <NasDataGrid
              buildings={buildings}
              onSave={handleSave}
              nasProfile={nasProfile}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
